"use client";

import desktopMediaQuery from "@casino/ui/Games/desktopMediaQuery";
import { useMediaQuery } from "@workspace/frontend-ui";
import type { FC } from "react";
import GameStatsDrawer from "./GameStatsDrawer";
import GameStatsPopover from "./GameStatsPopover";

type Props = { game?: SingleGameFragment; isLiveRtpEnabled?: boolean };

const InfoButton: FC<Props> = ({ game, isLiveRtpEnabled }) => {
  const isDesktop = useMediaQuery(desktopMediaQuery);

  if (!game) return null;
  if (isDesktop) {
    return <GameStatsPopover game={game} isLiveRtpEnabled={isLiveRtpEnabled} />;
  }
  return <GameStatsDrawer game={game} isLiveRtpEnabled={isLiveRtpEnabled} />;
};

export default InfoButton;
export { default as GameStatsAccordion } from "./GameStatsAccordion";
